<template>
  <N2PaginaContacto v-if="disenoPropio" />
  <div v-else-if="NOTARIA">

    <!-- Start Breadcrump Area  -->
    <SliderBannerNotinTwo :obj="NOTARIA.Theme.Contacto" type="contacto"/>
    <!-- End Breadcrump Area  -->

    <!-- Start Contact Address Area  -->
    <ContactAddressNotinTwo v-if="NOTARIA.Theme.Contacto.Tipo === 'moderno'" />
    <ContactAddressNotinOne v-else />
    <!-- End Contact Address Area  -->

    <!-- Start Contact Area  -->
    <template v-if="NOTARIA && NOTARIA.Theme && NOTARIA.Theme.Contacto.Form.Mostrar">
      <!-- El diseño Guiado (Design === 2) se muestra cuando la notaría lo tiene configurado -->
      <ContactFormGuiado class="home-section" v-if="NOTARIA.Theme.Contacto.Form.Design === 2" :contactForm="style.ThemeFormContact" />
      <ContactFormPersonalizado class="home-section" v-else-if="NOTARIA.Theme.Contacto.Form.Design === 3" :contactForm="style.ThemeFormContact" />
      <ContactFormNotinTwo class="home-section" v-else-if="NOTARIA.Theme.Contacto.Form.Design === 1 || NOTARIA.Theme.Contacto.Form.Design === null || NOTARIA.Theme.Contacto.Form.Design === undefined" :contactForm="style.ThemeFormContact" />
      <ContactFormNotinOne class="home-section" v-else :contactForm="style.ThemeFormContact" />
    </template>
    <!-- End Contact Area  -->

    <!-- Start Brand Area -->
    <!-- <div class="rn-brand-area brand-separation rn-section-gap bg_color--5">
      <v-container>
        <Brand />
      </v-container>
    </div> -->
    <!-- End Brand Area -->
  </div>
</template>

<script setup lang="ts">
// Plantillas 2 a 5: la página con el diseño de su portada (refs: https://trello.com/c/3g3PTnq5, https://trello.com/c/MGgrmuPY, https://trello.com/c/XU15s9gl, https://trello.com/c/0Ma2vfxV)
import N2PaginaContacto from '../components/notaria2/N2PaginaContacto.vue'
import { useDisenoPropio } from '../composables/useNotaria2'
const disenoPropio = useDisenoPropio()
import { useStore } from '../store/index'
const store = useStore()
import { useStyles } from '../store/styles';
const style = useStyles();
const {NOTARIA} = storeToRefs(store)
const PageName = "Contacto"
if(store.NOTARIA) useMetaTags(toRaw(store.NOTARIA),PageName)
</script>
